import { render, staticRenderFns } from "./ModalAddModulo.vue?vue&type=template&id=d10289cc&"
import script from "./ModalAddModulo.vue?vue&type=script&lang=js&"
export * from "./ModalAddModulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports